export { ErrorState } from '@microservices/design-system';
export type { ErrorStateProps } from '@microservices/design-system';
